import { Box, Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import type { SingleValueProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { Text } from '@feathr/components';

import type { IAdDimensionOption } from './AdDimensionsSelect.types';

function AdDimensionSingleValue(props: SingleValueProps<IAdDimensionOption>): JSX.Element {
  const { data } = props;
  const theme = useMantineTheme();

  return (
    <components.SingleValue {...props}>
      <Flex align={'center'} gap={theme.spacing['3']}>
        <Text.DefaultMedium>{data.name}</Text.DefaultMedium>
        <Box ml={'auto'}>
          <Text.SmallRegular>
            {data.width}x{data.height} · {data.aspectRatio}
          </Text.SmallRegular>
        </Box>
      </Flex>
    </components.SingleValue>
  );
}

export default AdDimensionSingleValue;
